import { HarvestIntegration } from 'appJS/components/Integrations/types';
import { ReactNode } from 'react';
import { View } from '../project_board/project_nav/types';

export enum ActiveKey {
  General = 'general',
  Integrations = 'integrations',
  InstallBugherd = 'install_bugherd',
  GuestPermissions = 'guest_permissions',
  Security = 'security',
  Sidebar = 'sidebar',
  Tags = 'tags',
  CommitHook = 'commit_hook',
  ExportBugs = 'export_bugs',
  DisableDeleteProject = 'disable_delete_project',
  Advanced = 'advanced',
  TestProjectSidebar = 'test_project_sidebar',
  AISettings = 'bugherd-ai'
}

export type IntegrationSettingsProps = {
  project?: {
    organizationId?: string;
    id: string;
    webhooks?: Object;
  };
  zapier?: {
    id: string;
  };
  legacyIntegrations?: object;
  premiumAllowed?: boolean;
  premiumIntegrationsAllowed?: boolean;
  editingAllowed?: boolean;
  bugherdUrl?: string;
  ownerEmail?: string;
  harvestIntegration?: HarvestIntegration;
  trialUser?: boolean;
  webhooksPath?: string;
  apiKey?: string;
  mcpConnectedClientNames?: string[];
  authProviders?: string[];
  connectors?: object[];
  user?: any;
  bitBucketHook?: string;
  gitHubHook?: string;
  gitLabHook?: string;
  currentUser: {
    id: string;
    name: string;
    email: string;
    viewedGuestProjectBoard: boolean;
    role: string;
  };
  openIntegration?: string;
};
export interface NewSettingsProps {
  projectInit: any;
  accessTo: {
    guestsSeeGuestsAccess: boolean;
    guestsEditTaskStatusAllowed: boolean;
    mobileScreenshots: boolean;
    billing: boolean;
    aiFeatures: boolean;
  };
  integrations: IntegrationSettingsProps;
  bugherdUrl: string;
  bitBucketHook: string;
  gitHubHook: string;
  gitLabHook: string;
  user: any;
  activeKey: ActiveKey;
  setActiveKey: (activeKey: ActiveKey) => void;
  setView: (view: View) => void;
  authenticityToken: string;
  view: View | null;
  showAssetsPage: () => void;
  collapsed: boolean;
  currentUser: {
    id: string;
    name: string;
    email: string;
    viewedGuestProjectBoard: boolean;
    role: string;
  };
  container: HTMLDivElement;
}

export type GetItemArgs = {
  key: string;
  children?: ReactNode;
  label: ReactNode;
};

export type TabItems = {
  project: any;
  accessTo: any;
  bugherdUrl: string;
  integrations?: IntegrationSettingsProps;
  user: any;
  bitBucketHook?: string;
  gitHubHook?: string;
  gitLabHook?: string;
  refetch: () => void;
  projectInit: any;
  authenticityToken: string;
  showAssetsPage: () => void;
  currentUser: {
    id: string;
    name: string;
    email: string;
    viewedGuestProjectBoard: boolean;
    role: string;
  };
  collapsed: boolean;
  container: HTMLDivElement;
};

export type CommitProps = {
  bitBucketHook?: string;
  gitHubHook?: string;
  gitLabHook?: string;
  projectId: string;
  organizationId: string;
};
